import { render, staticRenderFns } from "./CafeFancafe.vue?vue&type=template&id=613c17fd"
import script from "./CafeFancafe.vue?vue&type=script&lang=js"
export * from "./CafeFancafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports